import { Formik } from "formik";
import { format } from "date-fns";
import { Col, Form, Row, } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import styles from "./AmountDetails.module.scss";
import NoContent from "../../../../common/NoContent/NoContent";
import CommonDatePicker from "../../../../common/Formik/DatePiker/DatePicker";
import transactionIcon from "../../../../../assets/icons/transactionIcon.svg";
import { getUnbiledTransactionsAction } from "../../../../../features/user/userSlice";
import { GreenArrowIcon, RedArrowIcon } from "../../../../../assets/icons/svgicons";
import Button from "../../../../common/Button/Button";
import Table from "../../../../common/Table/Table";
import Select from "../../../../common/Formik/Select/Select";
import InputFormik from "../../../../common/Formik/Input/InputFormik";
import { useDebounce } from "../../../../customHook/useDebeunce";

const AmountDetails = ({ cardId, activeTab }) => {
  const dispatch = useDispatch();
  const [endDate, setEndDate] = useState("");
  const [search, setSearch] = useState("");
  const debounced = useDebounce(search, 500);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [unBilledData, setUnbilledData] = useState({})
  const [filter, setFilter] = useState({ value: "All", label: "All" });

  const getUnbiledTranstion = async () => {
    if (!cardId) return;
    try {
      setLoading(true);
      const payload = {
        ...(debounced && { search: debounced }),
        ...(filter?.value !== "All" && { transactionType: filter.value }),
        ...(startDate && endDate && {
          startDate: format(new Date(startDate), "yyyy-MM-dd"),
          endDate: format(new Date(endDate), "yyyy-MM-dd"),
        }),
      };
      const res = await dispatch(getUnbiledTransactionsAction(payload, cardId));
      if (res.status === 200) {
        setUnbilledData(res?.data?.data)
      }
    } catch (error) {
      console.log("Error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!cardId || activeTab !== "unbilledTransactions") return;

    const noDatesSelected = !startDate && !endDate;
    const bothDatesSelected = startDate && endDate;

    if (noDatesSelected || bothDatesSelected) {
      getUnbiledTranstion();
    }
  }, [cardId, activeTab, startDate, endDate, debounced, filter]);

  const handleResetDates = (formik) => {
    formik.resetForm();
    setStartDate("");
    setEndDate("");
  };

  const fields = [
    { label: "Transaction Id", value: "amount" },
    { label: "Amount", value: "bill_number" },
    { label: "Transaction Status", value: "paid_amount" },
    { label: "Type", value: "paid_amount" },
    { label: "Date & Time", value: "previous_balance" },
  ]
  const options = [
    { value: "All", label: "All" },
    { value: "load", label: "Top Up" },
    { value: "spend", label: "Spend" },
  ];


  return (
    <>
      {/* {activeTab !== 'cardStatement' && <div className={styles.AmountDetails_content}>
        <Row>
          <Col lg={6}>
            <div className={styles.AmountDetails_content_left}>
              <h4 className={styles.heading}>Balance Details</h4>
              <ul>
                <li>
                  <label>Unbilled Amount</label>
                  <h4>${unBilledData?.totalAmount || 0}</h4>
                </li>
                <li>
                  <label>Outstanding Amount </label>
                  <h4>$11,879.75</h4>
                </li>

              </ul>
            </div>
          </Col>
          <Col lg={6}>
            <div className={styles.AmountDetails_content_right}>
              <h4 className={styles.heading}>Available Limits</h4>
              <ul className={styles.light_blue}>
                <li>
                  <label>Credit Limit</label>
                  <h4>$67,148.56</h4>
                </li>
                <li>
                  <label>Cash Limt</label>
                  <h4>$23,000.00</h4>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
      } */}
      <section className={styles.AmountDetails}>
        <div className={styles.recent_AmountDetails}>
          <div className={styles.recent_AmountDetails_head}>
            <h4>Unbilled transactions</h4>
            <div className={styles.recent_AmountDetails_head_rightSec}>
              <Formik
                initialValues={{
                  startdate: "",
                  enddate: "",
                }}
                // onSubmit={(values) => console.log("Form Submitted:", values)}
                onSubmit={(values) => {}}
              >
                {(formik) => (
                  <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <InputFormik
                      name="amount"
                      value={search}
                      variant="large_height"
                      className="fieldinput"
                      placeholder="Enter Transaction ID"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    &nbsp; &nbsp;
                    <Select
                      className="select_time"
                      name="filter"
                      options={options}
                      value={filter}
                      onChange={(value) => setFilter(value)}
                      isSearchable
                    />
                    <CommonDatePicker
                      className="datepickerfield"
                      name="startdate"
                      value={startDate}
                      placeholder="Start Date"
                      onChange={(date) => setStartDate(date)}
                      // minDate={new Date()}
                      formik={formik}
                    />
                    <CommonDatePicker
                      className="datepickerfield"
                      name="enddate"
                      value={endDate}
                      placeholder="End Date"
                      onChange={(date) => setEndDate(date)}
                      // minDate={new Date()}
                      formik={formik}
                    />
                    <Button
                      className={styles.resetBtn}
                      variant='xtra_small danger_filled'
                      type="button"
                      onClick={(e) => {
                        handleResetDates(formik);
                      }}
                      disabled={!startDate && !endDate}
                    >
                      Reset Dates
                    </Button>
                  </form>
                )}
              </Formik>

            </div>
          </div>
          &nbsp;
          <Table
            noRecordContent={"No records for your search were found."}
            fields={fields}
            className='table'
            loading={loading}
            noRecordVariant={"large"}
            noRecordClassName={styles.no_content}
            loadingClassName={"loading_table"}
          >
            {unBilledData?.transactions?.length > 0 ?
              unBilledData?.transactions?.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item?.external_transaction_id
                      ? item.external_transaction_id
                      : item?.id}
                  </td>
                  <td>
                    {item?.amount / 100000000}
                    &nbsp;
                    <span>{item?.transaction_type_api === "spend" ? <RedArrowIcon /> : <GreenArrowIcon />}</span>
                  </td>
                  <td>{item?.transaction_status}</td>
                  <td>{item?.transaction_type_api === "load" ? "Top Up" : "Spend"}</td>
                  <td>{item?.created_at &&
                    !isNaN(
                      new Date(item?.created_at).getTime()
                    )
                    ? format(
                      new Date(item?.created_at),
                      "dd MMM, yyyy hh:mm a"
                    )
                    : "Invalid date"}</td>
                </tr>
              )) :
              <tr>
                <td colSpan={fields.length}>
                  <NoContent
                    className={styles.no_record}
                  />
                </td>
              </tr>
            }
          </Table>
        </div>
      </section>
    </>
  );
};

export default AmountDetails;
